import request from '@/utils/request'

// 查询APP版本列表
export function listAppVersion(query) {
  return request({
    url: '/biz/app-version/list',
    method: 'get',
    params: query
  })
}

// 查询APP版本分页
export function pageAppVersion(query) {
  return request({
    url: '/biz/app-version/page',
    method: 'get',
    params: query
  })
}

// 查询APP版本详情
export function getAppVersion(data) {
  return request({
    url: '/biz/app-version/detail',
    method: 'get',
    params: data
  })
}

// 新增APP版本
export function addAppVersion(data) {
  return request({
    url: '/biz/app-version/add',
    method: 'post',
    data: data
  })
}

// 修改APP版本
export function updateAppVersion(data) {
  return request({
    url: '/biz/app-version/edit',
    method: 'post',
    data: data
  })
}

// 删除APP版本
export function delAppVersion(data) {
  return request({
    url: '/biz/app-version/delete',
    method: 'post',
    data: data
  })
}

// 下载二维码：获取下载配置（两端；包名可编辑，iOS/Android 链接只读展示）
export function listDownloadConfig() {
  return request({
    url: '/biz/app-version/download-config',
    method: 'get'
  })
}

// 下载二维码：保存下载配置（仅 Android 包名）
export function saveDownloadConfig(data) {
  return request({
    url: '/biz/app-version/download-config',
    method: 'post',
    data: data
  })
}
